var render = function () {
  var _vm$data, _vm$data2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    attrs: {
      "title": (_vm$data = _vm.data) !== null && _vm$data !== void 0 && _vm$data.PaymentCode ? _vm.$t('ar_client_edit_bill') : _vm.$t('ar_client_create_bill'),
      "centered": "",
      "dialog-class": "d-class"
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function () {
        return [_c('LoadingModalButton', {
          ref: "buttonRef",
          attrs: {
            "usingTimeOutSubmit": true
          },
          on: {
            "click": _vm.acceptDataAddVoucher
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("ar_common_save")) + " ")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.isShow,
      callback: function ($$v) {
        _vm.isShow = $$v;
      },
      expression: "isShow"
    }
  }, [_c('validation-observer', {
    ref: "formRef"
  }, [_c('b-row', {
    staticClass: "w-100 p-1 m-0"
  }, [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('validation-provider', {
    attrs: {
      "rules": "required",
      "name": _vm.$t('ar_client_company')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var errors = _ref.errors;
        return [_c('b-form-group', {
          staticClass: "label-requires",
          attrs: {
            "label": _vm.$t('ar_client_company') + ':'
          }
        }, [_c('WidgetSelect', {
          attrs: {
            "errors": errors,
            "customOptions": function (options) {
              return options.map(function (option) {
                return Object.assign({}, option, {
                  CodeName: ((option.TravelAgentCode) + " - " + (option.NameVi))
                });
              });
            },
            "disabled": _vm.readOnly,
            "label": "CodeName",
            "placeholder": "ar_voucher_select_company",
            "dataSource": _vm.arClient.api_AR_RCL01,
            "dataSourceParams": {
              IsCheckPermission: false
            }
          },
          model: {
            value: _vm.valSelectCompany,
            callback: function ($$v) {
              _vm.valSelectCompany = $$v;
            },
            expression: "valSelectCompany"
          }
        })], 1), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1), _c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "md": "6"
    }
  }, [_c('validation-provider', {
    attrs: {
      "rules": "required|max:100",
      "name": _vm.$t('ar_client_payer')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref2) {
        var errors = _ref2.errors;
        return [_c('b-form-group', {
          staticClass: "label-requires",
          attrs: {
            "label": _vm.$t('ar_client_payer') + ':'
          }
        }, [_c('b-form-input', {
          attrs: {
            "state": errors.length > 0 ? false : null,
            "disabled": _vm.readOnly
          },
          model: {
            value: _vm.submitterVal,
            callback: function ($$v) {
              _vm.submitterVal = $$v;
            },
            expression: "submitterVal"
          }
        })], 1), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  }), _c('validation-provider', {
    attrs: {
      "name": _vm.$t('ar_clinent_create_code_payment')
    }
  }, [_c('div', {
    staticClass: "d-flex align-items-center mt-3"
  }, [_c('label', {
    staticClass: "mr-2"
  }, [_vm._v(_vm._s(_vm.$t("ar_client_auto_create_payment_code")))]), _c('b-form-checkbox', {
    attrs: {
      "disabled": (_vm$data2 = _vm.data) === null || _vm$data2 === void 0 ? void 0 : _vm$data2.PaymentCode,
      "switch": ""
    },
    model: {
      value: _vm.isAutoCreateCode,
      callback: function ($$v) {
        _vm.isAutoCreateCode = $$v;
      },
      expression: "isAutoCreateCode"
    }
  })], 1)])], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('validation-provider', {
    attrs: {
      "rules": "required|max:100",
      "name": _vm.$t('ar_client_payment_date')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref3) {
        var _vm$data3, _vm$data4;
        var errors = _ref3.errors;
        return [_c('b-form-group', {
          staticClass: "label-requires",
          attrs: {
            "label": _vm.$t('ar_client_payment_date')
          }
        }, [((_vm$data3 = _vm.data) === null || _vm$data3 === void 0 ? void 0 : _vm$data3.TotalAmount) <= 0 || !((_vm$data4 = _vm.data) !== null && _vm$data4 !== void 0 && _vm$data4.PaymentDate) ? _c('date-range-picker', {
          attrs: {
            "clearable": false,
            "max-date": _vm.dayjs().endOf('day'),
            "single-date-picker": true,
            "opens": "right",
            "ranges": false,
            "time-picker": true,
            "time-picker-increment": 1,
            "show-dropdowns": true,
            "auto-apply": false,
            "locale-data": _vm.isViLanguage ? {
              format: 'dd/mm/YYYY',
              daysOfWeek: ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7'],
              monthNames: ['Tháng 1', 'Tháng 2', 'Tháng 3', 'Tháng 4', 'Tháng 5', 'Tháng 6', 'Tháng 7', 'Tháng 8', 'Tháng 9', 'Tháng 10', 'Tháng 11', 'Tháng 12'],
              firstDay: 0
            } : undefined
          },
          model: {
            value: _vm.dateOfFiling,
            callback: function ($$v) {
              _vm.dateOfFiling = $$v;
            },
            expression: "dateOfFiling"
          }
        }) : _c('b-form-input', {
          attrs: {
            "disabled": true,
            "value": _vm.dayjs(_vm.dateOfFiling).format('DD/MM/YYYY')
          }
        })], 1), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  }), _c('validation-provider', {
    attrs: {
      "rules": {
        code: !_vm.isAutoCreateCode,
        required: !_vm.isAutoCreateCode,
        max: 13,
        min: 2
      },
      "name": _vm.$t('ar_client_payment_code')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref4) {
        var _vm$data5;
        var errors = _ref4.errors;
        return [_c('b-form-group', {
          staticClass: "label-requires",
          attrs: {
            "label": _vm.$t('ar_client_payment_code') + ':'
          }
        }, [_c('WidgetCleave', {
          attrs: {
            "errors": errors /* .length > 0 ? errors : duplicateCodeMessages[0] */,
            "type": "uppercase",
            "disabled": ((_vm$data5 = _vm.data) === null || _vm$data5 === void 0 ? void 0 : _vm$data5.PaymentCode) || _vm.isAutoCreateCode
          },
          model: {
            value: _vm.paymentCode,
            callback: function ($$v) {
              _vm.paymentCode = $$v;
            },
            expression: "paymentCode"
          }
        })], 1), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0] /* || duplicateCodeMessages[0] */))])];
      }
    }])
  })], 1), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('validation-provider', {
    attrs: {
      "rules": "max:255",
      "name": _vm.$t('ar_client_account_note')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref5) {
        var errors = _ref5.errors;
        return [_c('b-form-group', {
          attrs: {
            "label": _vm.$t('ar_client_account_note')
          }
        }, [_c('b-form-textarea', {
          attrs: {
            "rows": 6
          },
          model: {
            value: _vm.note,
            callback: function ($$v) {
              _vm.note = $$v;
            },
            expression: "note"
          }
        })], 1), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }